import noUiSlider from 'nouislider'
import wNumb from 'wnumb'
import { getSectionFromHTML } from '@surf-turf/nemo/assets/utils-section-injection'
import axios from 'axios'

class filterComponent extends HTMLElement {
  constructor() {
    super()

    const filterComponentElement = this

    const init = () => {
      handleFilterClose()
      handleFilterOpenButton()
      handlePriceFilter()
      handleSort()
      handleFilterButtons()
    }

    const handleOutsideClick = () => {
      document.addEventListener('closeMenu', function (e) {
        closeFilter()
      })

      document.addEventListener('click', function (e) {
        if (e.target.classList.contains('js-open-filter') || filterComponentElement.contains(e.target)) {
          // do nothing
        } else {
          const event = new Event('closeMenu')
          document.dispatchEvent(event)
        }
      })
    }

    /**
     * Handle filter close button click
     */
    const handleFilterClose = () => {
      const buttons = document.querySelectorAll('.js-close-filter')

      if (buttons.length > 0) {
        buttons.forEach((button) => {
          button.addEventListener('click', (e) => {
            e.preventDefault()
            closeFilter()
          })
        })
      }
    }

    window.onkeydown = function (event) {
      if (event.keyCode == 27) {
        closeFilter()
      }
    }

    const closeFilter = () => {
      filterComponentElement.classList.remove('js-open')
      filterComponentElement.classList.add('js-close')
    }

    /**
     * Handle filter open button click
     */
    const handleFilterOpenButton = () => {
      const buttons = document.querySelectorAll('.js-open-filter')

      if (buttons.length > 0) {
        buttons.forEach((button) => {
          button.addEventListener('click', (e) => {
            e.preventDefault()
            filterComponentElement.classList.remove('js-close')
            filterComponentElement.classList.add('js-open')
            handleOutsideClick()
          })
        })
      }
    }

    /**
     * Handle filter price range slider
     */

    const handlePriceFilter = () => {
      const slider = document.getElementById('price-slider')

      if (!slider) return false

      const minValue = parseFloat(slider.dataset.min)
      const step = 100
      let maxValue = parseFloat(slider.dataset.max)
      let selectedMinValue = parseFloat(slider.dataset.selectedMin)
      let selectedMaxValue = parseFloat(slider.dataset.selectedMax)

      // Make the maxValue rounded up to the nearest step
      maxValue = Math.round(maxValue / step) * step
      const procent25 = maxValue / 4
      const procent50 = maxValue / 2
      const procent75 = (maxValue / 4) * 3

      // Set the slider to the max if the max is the Shopify max value
      if (maxValue === Math.round(selectedMaxValue / step) * step) {
        selectedMaxValue = maxValue
      }

      const range = {
        min: [minValue],
        '25%': [procent25, step],
        '50%': [procent50, step],
        '75%': [procent75, step],
        max: [maxValue, step],
      }

      if (selectedMaxValue === 1) {
        selectedMaxValue = maxValue
      }

      noUiSlider.create(slider, {
        start: [selectedMinValue, selectedMaxValue],
        step: step,
        connect: true,
        range: range,
        tooltips: wNumb({
          decimals: 0,
          prefix: '€ ',
        }),
        pips: {
          mode: 'range',
          stepped: true,
          density: 4,
          format: wNumb({
            decimals: 0,
            prefix: '€ ',
          }),
        },
      })

      // Update the Shopify price range fields
      slider.noUiSlider.on('update', (values) => {
        const minInput = document.getElementById('Filter-filter.v.price.gte')
        const maxInput = document.getElementById('Filter-filter.v.price.lte')

        // Only set the values of the inputs when they are not equal to the limits
        if (parseInt(values[0]) === 0 && Math.round(parseInt(values[1]) / step) * step === maxValue) {
          minInput.value = ''
          maxInput.value = ''
        } else {
          minInput.value = parseInt(values[0])
          maxInput.value = parseInt(values[1])
        }
      })
    }

    /**
     * Handle sort function
     */
    const handleSort = () => {
      // Update sort_by query parameter on select change
      document.querySelector('#sort-by').addEventListener('change', function (e) {
        Shopify.queryParams = {}

        // Preserve existing query parameters
        if (location.search.length) {
          var params = location.search.substr(1).split('&')

          for (var i = 0; i < params.length; i++) {
            var keyValue = params[i].split('=')

            if (keyValue.length) {
              Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1])
            }
          }
        }

        var value = e.target.value

        Shopify.queryParams.sort_by = value
        location.search = new URLSearchParams(Shopify.queryParams).toString()
      })
    }

    /**
     * @param {HTMLDom} dom
     * @param {sectionsArray} sectionsArray
     * renders product filters
     */
    const renderSections = (dom, sectionsArray) => {
      sectionsArray.forEach((section) => {
        const source = dom.querySelector(section)
        const destination = document.querySelector(section)
        destination.innerHTML = source.innerHTML
      })
    }

    /**
     * Listen to filter buttons
     */
    const handleFilterButtons = () => {
      const form = filterComponentElement.querySelector('form')
      const inputs = form.querySelectorAll('input')

      if (inputs) {
        inputs.forEach((input) => {
          input.addEventListener('change', () => {
            handleFilterApply(form)
          })
        })
      }
    }

    /**
     * Use section rendering
     */
    const handleFilterApply = (form) => {
      const sectionID = document.querySelector('collection-component').id
      const buttons = form.querySelectorAll('.default-filter__button input, .color-filter__button input')

      // Create empty string for parameters
      let params = ''

      buttons.forEach((button) => {
        if (button.checked == true) {
          params += '&' + button.name + '=' + button.value
        }
      })

      // Get the min and max price
      const priceSlider = document.getElementById('price-slider')
      if (priceSlider) {
        const minValueElement = form.querySelector('.noUi-handle-lower')
        const maxValueElement = form.querySelector('.noUi-handle-upper')
        const maxValue = document.getElementById('price-slider').dataset.max

        if (minValueElement && maxValueElement) {
          if (
            minValueElement.getAttribute('aria-valuenow') !== minValueElement.getAttribute('') &&
            parseInt(minValueElement.getAttribute('aria-valuenow')) !== 0
          ) {
            params += '&filter.v.price.gte=' + parseInt(minValueElement.getAttribute('aria-valuenow'))
          }
          if (
            maxValueElement.getAttribute('aria-valuenow') !== maxValueElement.getAttribute('aria-valuemax') &&
            parseInt(maxValueElement.getAttribute('aria-valuenow')) !== parseInt(maxValue)
          ) {
            params += '&filter.v.price.lte=' + parseInt(maxValueElement.getAttribute('aria-valuenow'))
          }
        }
      }

      axios
        .get(window.location.pathname + '?sections=' + sectionID + params)
        .then((res) => {
          const parser = new DOMParser()
          const dom = parser.parseFromString(res.data[sectionID], 'text/html')
          const sectionsArray = ['.collection-grid', '.anchor-nav__items', '.filter__group__container', '.footer__active-filters']
          renderSections(dom, sectionsArray)
          history.pushState(null, null, window.location.pathname + '?' + params.trim().replace(/^&/, ''))
          handleFilterButtons()
        })
        .catch((err) => {
          // Handle Error Here
          console.error(err)
        })
    }

    init()
  }
}

customElements.define('filter-component', filterComponent)
